module.exports = __webpack_public_path__ + "img/bg-icon.2f883766.svg";